<template>
  <v-select
    v-model="selectedUser"
    placeholder="Search users"
    label="phoneNumber"
    :options="filteredUsers"
    :clearable="clearable"
    :filterable="filterable"
    v-bind="$attrs"
    @search="fetchUsers"
    @input="selectUser"
  />
</template>

<script>
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { debounce } from 'lodash'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import usersStore from '@/views/users/rider/store'

export default {
  components: {
    vSelect,
  },
  props: {
    autoReset: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('users', usersStore)
    const selectedUser = ref(null)
    const filteredUsers = ref([])
    const fetchUsers = debounce(async (search, loading) => {
      if (!search) return
      loading(true)
      let temp = search
      if (search.startsWith('00')) {
        temp = `+${search.substr(2)}`
      }
      if (search.startsWith('+')) {
        temp = `${search.substr(1)}`
      }
      const res = await ctx.root.$store.dispatch('users/fetchUsers', {
        text: temp,
      })
      filteredUsers.value = res.data.data.users
      loading(false)
    }, 1000)

    const selectUser = e => {
      if (e) {
        ctx.emit('users-selection', e)
        if (props.autoReset) {
          selectedUser.value = null
        }
      }
    }
    if (props.value) {
      filteredUsers.value.push({
        label: 'phoneNumber',
        value: props.value,
      })
    }
    selectedUser.value = props.value

    const resetValue = () => {
      selectedUser.value = null
    }

    return {
      fetchUsers,
      filteredUsers,
      resetValue,
      selectUser,
      selectedUser,
    }
  },
}
</script>
